export type ChequeVisualSettings = {
  sealDataUrl: string;
  signatureDataUrl: string;
};

const KEY = 'accounting_cheque_seal_sign_v1';

const DEFAULTS: ChequeVisualSettings = {
  sealDataUrl: '',
  signatureDataUrl: '',
};

export function getChequeVisualSettings(): ChequeVisualSettings {
  if (typeof window === 'undefined') return DEFAULTS;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return DEFAULTS;
    return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<ChequeVisualSettings>) };
  } catch {
    return DEFAULTS;
  }
}

export function saveChequeVisualSettings(value: ChequeVisualSettings): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(KEY, JSON.stringify(value));
}
